module.exports = __webpack_public_path__ + "img/Nano.5d0e62c4.png";